<template>
    <div class="empty-placeholder">
        <a-icon
            icon="Attention"
            class="text-orange"
            width="64"
            height="64"
        />
        <div class="mt-3">
            <slot v-if="$slots.default" />
            <template v-else-if="text">{{ text }}</template>
            <template v-else>
                Przepraszamy, raport dla Twojego sklepu jest niedostępny.<br />
            </template>
            <template v-if="email">
                Napisz na
                <a class="text-primary text-underline" :href="`mailto:${email}`" v-text="email" />
            </template>
        </div>
    </div>
</template>

<script>
import { EMAILS } from '@/utils/constants/emails'
export default {
    props: {
        text: {
            type: String,
            required: false
        },
        email: {
            type: String,
            default: '',
            validator: value => {
                return [EMAILS.ECSP, EMAILS.KPL, ''].includes(value)
            }
        }
    }
}
</script>

<style lang="scss">
.empty-placeholder {
    text-align: center;
    font-size: 16px;
    color: var(--color-primary);
    font-weight: 500;
    line-height: 1.32;
}
</style>